import styled from 'styled-components';

import bg from '~/assets/tv/implants/balls-bg.png';

interface ISlide {
  show: boolean;
  startAnim: boolean;
  notShow?: boolean;
}

export const Container = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  transition-duration: 0.3s;
  opacity: ${(props) => (props.show ? 1 : 0)};
  background: #ebded0;
  min-width: 980px;
  min-height: 551.25px;
`;

export const Slide1 = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  transition-duration: 0.3s;
  opacity: ${(props) => (props.show ? 1 : 0)};
  background: #e8af73;

  .slide-container {
    width: 980px;
    height: 551.25px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    z-index: 1;

    .bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 980px;
      height: 551.25px;
    }

    .detail {
      position: absolute;
      left: 0;
      top: 176.44px;
      width: 980px;
      height: 375px;
      border-radius: 100px 0px 0px 0px;
      background: #984f0e;
    }

    .dra-ivani {
      position: absolute;
      left: 0;
      top: 26px;
      width: 412px;
      height: 526px;
    }

    .name {
      position: absolute;
      left: 334.27px;
      top: 463.3px;
      width: 111.28px;
      color: #fff;
      font-size: 30px;
      font-weight: 500;
      line-height: 30.27px;
      text-align: right;
    }

    .content {
      position: absolute;
      left: 529.62px;
      top: 258.72px;
      width: 400.3px;
      color: #eebf8b;
      font-size: 30px;
      font-weight: 500;
      line-height: 30.18px;
      text-align: right;
    }
  }
`;

export const Slide2 = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  transition-duration: 0.3s;
  opacity: ${(props) => (props.show ? 1 : 0)};
  background-image: url(${bg});

  .slide-container {
    width: 980px;
    height: 551.25px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    z-index: 1;

    .plenum {
      position: absolute;
      left: 82.05px;
      top: 77.17px;
      width: 132.25px;
      height: 35px;
    }

    .title {
      position: absolute;
      left: 82.05px;
      top: 291.54px;
      width: 429.96px;
      color: #202020;
      font-size: 40px;
      font-weight: 300;
      line-height: 56.36px;

      span {
        font-weight: 500;
      }
    }

    .implant {
      position: absolute;
      left: 642px;
      top: 204px;
      width: 154px;
      height: 347px;
    }
  }
`;

export const Slide3 = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  transition-duration: 0.3s;
  opacity: ${(props) => (props.show ? 1 : 0)};
  background-image: url(${bg});

  .slide-container {
    width: 980px;
    height: 551.25px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    z-index: 1;

    .title {
      position: absolute;
      left: 71.79px;
      top: 108.82px;
      width: 298.85px;
      color: #985000;
      font-size: 40px;
      font-weight: 600;
      line-height: 42.8px;
    }

    .before-after {
      position: absolute;
      left: 488.64px;
      top: 80.82px;
      width: 423.75px;
      height: 157px;
    }

    .content {
      position: absolute;
      left: 71.79px;
      top: 264.36px;
      width: 550.09px;
      color: #996022;
      font-size: 20px;
      font-weight: 500;
      line-height: 25px;
      letter-spacing: -1px;
    }

    .tag {
      position: absolute;
      width: max-content;
      padding: 8.81px 23.18px;
      border-radius: 87px;
      border: 2px solid #984f0e;
      color: #000;
      font-size: 24px;
      font-weight: 400;
      line-height: 33.81px;
    }

    .tag-1,
    .tag-2 {
      top: 378.46px;
    }

    .tag-1,
    .tag-3 {
      left: 71.79px;
    }

    .tag-3,
    .tag-4 {
      top: 447.76px;
    }

    .tag-2 {
      left: 406px;
    }

    .tag-4 {
      left: 472px;
    }
  }
`;
